/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M6 12H18"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M12 4.5V9M12 9L10 6.99999M12 9L14 7.00001M12 19.5L12 15M12 15L10 17M12 15L14 17M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<rect
				opacity="0.12"
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				fill="currentColor"
			/>
			<path
				d="M12 4.5V9M12 9L10 6.99999M12 9L14 7.00001M12 19.5L12 15M12 15L10 17M12 15L14 17M6 12H18M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.98005 1.79497C5.04961 1.25 6.44974 1.25 9.25 1.25H14.75C17.5503 1.25 18.9504 1.25 20.02 1.79497C20.9608 2.27433 21.7257 3.03924 22.205 3.98005C22.75 5.04961 22.75 6.44974 22.75 9.25V14.75C22.75 17.5503 22.75 18.9504 22.205 20.02C21.7257 20.9608 20.9608 21.7257 20.02 22.205C18.9504 22.75 17.5503 22.75 14.75 22.75H9.25C6.44974 22.75 5.04961 22.75 3.98005 22.205C3.03924 21.7257 2.27433 20.9608 1.79497 20.02C1.25 18.9504 1.25 17.5503 1.25 14.75V9.25C1.25 6.44974 1.25 5.04961 1.79497 3.98005C2.27433 3.03924 3.03924 2.27433 3.98005 1.79497ZM12.75 4.4999C12.75 4.08569 12.4142 3.7499 12 3.7499C11.5858 3.7499 11.25 4.08569 11.25 4.4999V7.18923L10.5303 6.46957C10.2374 6.17667 9.76257 6.17667 9.46968 6.46956C9.17678 6.76246 9.17678 7.23733 9.46968 7.53022L11.4697 9.53023C11.6103 9.67088 11.8011 9.7499 12 9.7499C12.1989 9.7499 12.3897 9.67089 12.5303 9.53023L14.5303 7.53024C14.8232 7.23735 14.8232 6.76247 14.5303 6.46958C14.2374 6.17669 13.7626 6.17669 13.4697 6.46958L12.75 7.18924V4.4999ZM6 11.25C5.58579 11.25 5.25 11.5858 5.25 12C5.25 12.4142 5.58579 12.75 6 12.75H18C18.4142 12.75 18.75 12.4142 18.75 12C18.75 11.5858 18.4142 11.25 18 11.25H6ZM12.5303 14.4697C12.3897 14.329 12.1989 14.25 12 14.25C11.8011 14.25 11.6103 14.329 11.4697 14.4697L9.46968 16.4697C9.17678 16.7626 9.17678 17.2374 9.46968 17.5303C9.76257 17.8232 10.2374 17.8232 10.5303 17.5303L11.25 16.8107L11.25 19.5C11.25 19.9142 11.5858 20.25 12 20.25C12.4142 20.25 12.75 19.9142 12.75 19.5L12.75 16.8107L13.4697 17.5303C13.7626 17.8232 14.2374 17.8232 14.5303 17.5303C14.8232 17.2374 14.8232 16.7626 14.5303 16.4697L12.5303 14.4697Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M9.5 2L9 2V2C7.13872 2 6.20808 2 5.45492 2.24472C3.93273 2.73931 2.73931 3.93273 2.24472 5.45492C2 6.20808 2 7.13872 2 9L2 14C2 16.8003 2 18.2004 2.54497 19.27C3.02434 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V9C22 7.13872 22 6.20808 21.7553 5.45492C21.2607 3.93273 20.0673 2.73931 18.5451 2.24472C17.7919 2 16.8613 2 15 2V2L14.5 2M12 4.5V9M12 9L10 6.99999M12 9L14 7.00001M12 19.5L12 15M12 15L10 17M12 15L14 17M6 12H18"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M12 4.5V9M12 9L10 6.99999M12 9L14 7.00001M12 19.5L12 15M12 15L10 17M12 15L14 17M6 12H18M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M9.25 1.25C6.44974 1.25 5.04961 1.25 3.98005 1.79497C3.03924 2.27433 2.27433 3.03924 1.79497 3.98005C1.25 5.04961 1.25 6.44974 1.25 9.25V14.75C1.25 17.5503 1.25 18.9504 1.79497 20.02C2.27433 20.9608 3.03924 21.7257 3.98005 22.205C5.04961 22.75 6.44974 22.75 9.25 22.75H14.75C17.5503 22.75 18.9504 22.75 20.02 22.205C20.9608 21.7257 21.7257 20.9608 22.205 20.02C22.75 18.9504 22.75 17.5503 22.75 14.75V9.25C22.75 6.44974 22.75 5.04961 22.205 3.98005C21.7257 3.03924 20.9608 2.27433 20.02 1.79497C18.9504 1.25 17.5503 1.25 14.75 1.25H9.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12 3.75C12.4142 3.75 12.75 4.08579 12.75 4.5V7.18934L13.4697 6.46968C13.7626 6.17678 14.2374 6.17678 14.5303 6.46968C14.8232 6.76257 14.8232 7.23744 14.5303 7.53034L12.5303 9.53033C12.3897 9.67098 12.1989 9.75 12 9.75C11.8011 9.75 11.6103 9.67098 11.4697 9.53033L9.46968 7.53032C9.17678 7.23743 9.17678 6.76255 9.46968 6.46966C9.76257 6.17677 10.2374 6.17677 10.5303 6.46967L11.25 7.18933V4.5C11.25 4.08579 11.5858 3.75 12 3.75ZM5.25 12.0001C5.25 11.5859 5.58579 11.2501 6 11.2501H18C18.4142 11.2501 18.75 11.5859 18.75 12.0001C18.75 12.4143 18.4142 12.7501 18 12.7501H6C5.58579 12.7501 5.25 12.4143 5.25 12.0001ZM12 14.2501C12.1989 14.2501 12.3897 14.3291 12.5303 14.4698L14.5303 16.4698C14.8232 16.7627 14.8232 17.2375 14.5303 17.5304C14.2374 17.8233 13.7626 17.8233 13.4697 17.5304L12.75 16.8108L12.75 19.5001C12.75 19.9143 12.4142 20.2501 12 20.2501C11.5858 20.2501 11.25 19.9143 11.25 19.5001L11.25 16.8108L10.5303 17.5304C10.2374 17.8233 9.76257 17.8233 9.46968 17.5304C9.17678 17.2375 9.17678 16.7627 9.46968 16.4698L11.4697 14.4698C11.6103 14.3291 11.8011 14.2501 12 14.2501Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
